import api from 'mastodon/api';

/**
 * Signs out. With `allAccounts`, every account remembered by the account
 * switcher in this browser is signed out too.
 */
export async function logOut({ allAccounts = false } = {}) {
  try {
    const response = await api(false).delete<{ redirect_to?: string }>(
      allAccounts ? '/auth/sign_out?all_accounts=1' : '/auth/sign_out',
      { headers: { Accept: 'application/json' }, withCredentials: true },
    );

    if (response.status === 200 && response.data.redirect_to)
      window.location.href = response.data.redirect_to;
    else
      console.error(
        'Failed to log out, got an unexpected non-redirect response from the server',
        response,
      );
  } catch (error) {
    console.error('Failed to log out, response was an error', error);
  }
}
